var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMobileTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.7847L2.73611 4.55553L10 1.32636L17.2639 4.55553L10 7.7847ZM18.6319 3.94789L10 0.111084L1.36806 3.94789L0 4.55553L1.36806 5.16317L10 8.99997L18.6319 5.16317L20 4.55553L18.6319 3.94789ZM5 7.99303L3.63194 7.38539L1.36806 8.39233L0 8.99997L1.36806 9.60761L10 13.4444L18.6319 9.60761L20 8.99997L18.6319 8.39233L16.3681 7.38539L15 7.99303L17.2639 8.99997L10 12.2291L2.73611 8.99997L5 7.99303ZM3.63194 11.8298L1.36806 12.8368L0 13.4444L1.36806 14.0521L10 17.8889L18.6319 14.0521L20 13.4444L18.6319 12.8368L16.3681 11.8298L15 12.4375L17.2639 13.4444L10 16.6736L2.73611 13.4444L5 12.4375L3.63194 11.8298Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMobileTasks);
export default __webpack_public_path__ + "static/media/nav-mobile-tasks.3a9057ec4cfc0ee54f088648ed42e9f0.svg";
export { ForwardRef as ReactComponent };